<template>
  <div class="app-container">
    <el-form :model="queryParams" ref="queryForm" label-width="90px">
      <el-row :gutter="10" class="mb8">
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="查询人员" prop="queryUserName">
            <el-input v-model="queryParams.queryUserName" placeholder="请输入" clearable />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="查询时间" prop="createTime">
            <el-date-picker v-model="queryParams.createTime" value-format="yyyy-MM-dd" type="daterange" range-separator="-" style="width:100%" start-placeholder="开始日期" end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="联系人" prop="contactName">
            <el-input v-model="queryParams.contactName" placeholder="请输入" clearable />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6" >
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetQuery">清空</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-table v-loading="loading" :data="dataList">
      <el-table-column label="查询人员" min-width="230" align="center" prop="queryUserName" />
      <el-table-column label="查询时间" min-width="100" align="center" prop="createTime" />
      <el-table-column label="联系人" min-width="100" align="center" prop="contactName" />
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    />
  </div>
</template>

<script>
import { queryMobileQueryRecordList } from "@/api/crm/log";
import { amountFormat } from "@/utils/index";

export default {
  name: "logList",
  props: {
    customerId: {},
    contactId: {},
    height: {
      type: String,
      default() {
        return "250";
      }
    }
  },
  data() {
    return {
      total: 1,
      loading: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        createTime: [],
        queryUserName:'',
        contactName:''
      },
      dataList: [],
      amountFormat
    };
  },
  created() {
    console.log("执行查询初始化 ")
    this.getList();
  },
  methods: {
     /** 搜索按钮操作 */
    handleQuery() {
      this.getList();

    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.getList();
    },
    getList() {
      console.log("执行查询getList");
      let params = JSON.parse(JSON.stringify(this.queryParams));
      if (params.createTime && params.createTime.length > 1) {
        params.startDate = params.createTime[0]
        params.endDate = params.createTime[1]
      }
      params.createTime = undefined;

      this.queryMobileQueryRecordListParam(params);
    },
    queryMobileQueryRecordListParam(param){
      this.loading = true;
      console.log("queryMobileQueryRecordListParam");
      queryMobileQueryRecordList(param).then(response => {
          this.dataList = response.rows || [];
          this.total = response.total;
          this.loading = false;
        }
      ).catch(error => {
        this.loading = false;
      });
    }

  }
};
</script>
